export default __webpack_public_path__ + "static/media/2425 cutlery top.aa5e8ef0.png";